import { handleActions } from "redux-actions";
import actionCreators from "../../actions/top/my_circle_list";

const initialState = {
  myCircles: [],
  loading: true,
};

export default handleActions(
  {
    [actionCreators.top.mycircles.set]: (state, action) =>
      Object.assign({}, state, action.payload),
    [actionCreators.top.mycircles.success]: (state, action) =>
      Object.assign({}, state, action.payload.data, { loading: false }),
    [actionCreators.top.mycircles.failure]: (state, action) =>
      Object.assign({}, state, {
        errorStatus: action.payload.error,
        loading: false,
      }),
  },
  initialState
);
